__turbopack_context__.v({
  "background": "HB5Z3q_background",
  "container": "HB5Z3q_container",
  "isCompactHover": "HB5Z3q_isCompactHover",
  "isDisabled": "HB5Z3q_isDisabled",
  "isOpacity": "HB5Z3q_isOpacity",
});
